// extracted by mini-css-extract-plugin
module.exports = {"microsoftAdsRow":"hJ-z","microsoftAdsCard":"iJ-z"};